import { isNumber } from 'lodash';

export function calculateMinColumnWidths(columns, gridWidth, field, minWidth, includeScrollbar) {
    let totalColumnWidth = 0;
    let fieldColumnWidth = 0;
    let colWidth = minWidth;

    columns.forEach(prop => {
        if (prop && prop.props && prop.props.width !== undefined) {
            const width = isNumber(prop.props.width) ? prop.props.width : parseInt(prop.props.width.toString().substring(0, prop.props.width.indexOf('px')));
            if (prop.props.field === field) {
                fieldColumnWidth = width;
            }
            totalColumnWidth += width;
        }
        else if (prop && prop.width && prop.width !== undefined) {
            const width = isNumber(prop.width) ? prop.width : parseInt(prop.width.toString().substring(0, prop.width.indexOf('px')));
            if (prop.field === field) {
                fieldColumnWidth = width;
            }
            totalColumnWidth += width;

        }
    });

    if (totalColumnWidth < gridWidth) {
        const gapWidth = gridWidth - totalColumnWidth;
        fieldColumnWidth += gapWidth;
        colWidth = fieldColumnWidth;
    }

    return includeScrollbar ? colWidth - 20 : colWidth; // subtract for the scrollbar container
}
